import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

export const CommunityChatBox = ({
  locals,
  chatboxEl,
  mobileChatOpened,
  setMobileChatOpened,
}) => {
  const { t } = useTranslation("coaching-portal");
  const { activeUser } = locals;
  const { webAppTheme = "dark" } = activeUser;
  return (
    <div
      className={
        webAppTheme == "dark"
          ? `dark-conversation-container conversation-container`
          : `light-conversation-container conversation-container`
      }
    >
      <button
        className="only-show-mobile chat-back"
        onClick={() => setMobileChatOpened(false)}
      >
        <img
          alt={t("communityChat.backAlt")}
          src="/img/new-icons/arrow-square-left.svg"
          className={webAppTheme === "dark" ? "filter-white" : "filter-black"}
        />
        <span>{t("communityChat.back")}</span>
      </button>

      <div
        className={
          mobileChatOpened ? "chat-box chat-box-mobile-chat-opened" : "chat-box"
        }
        ref={chatboxEl}
      >
        <img src="/img/spinner.gif" width="50" height="50" alt={t("communityChat.spinnerAlt")} />
      </div>
    </div>
  );
};

CommunityChatBox.propTypes = {
  locals: PropTypes.object,
  chatboxEl: PropTypes.any,
  mobileChatOpened: PropTypes.bool,
  setMobileChatOpened: PropTypes.func,
};